import RadioCircle from '../RadioCircle/RadioCircle'
import {
  OuterContainer,
  InnerContainer,
  RadioWrapper,
  ContentContainer,
  Title,
  Description,
  Price
} from './PackageOption.styles'

export type PackageOptionProps = {
  title: string
  description: string
  price: string
  selected?: boolean
  onClick?: () => void
}

export default function PackageOption({
  title,
  description,
  price,
  selected,
  onClick
}: PackageOptionProps) {
  return (
    <OuterContainer $selected={selected} onClick={onClick}>
      <InnerContainer $selected={selected}>
        <RadioWrapper>
          <RadioCircle checked={selected} />
        </RadioWrapper>
        <ContentContainer>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </ContentContainer>
        <Price>{price}</Price>
      </InnerContainer>
    </OuterContainer>
  )
}
